module.exports = __webpack_public_path__ + "static/media/control_1.4c12ec5a.svg";